//
//
//
//
//
//
//
//
//
//
//
//
//

import RequestWorksSection from './RequestWorksSection.vue'
import { requestWorkTypes } from './RequestWorkTypes.js'

export default {
  name: 'RequestWorksSimpleSection',
  components: {
    RequestWorksSection
  },
  mixins: [requestWorkTypes],
  provide () {
    return { reportContentEnabled: false }
  },
  props: {
    request: {
      type: Object,
      default () {
        return {}
      }
    },
    requestRoles: {
      type: Object,
      default () {
        return {}
      }
    },
    requestInitial: {
      type: Object,
      default () {
        return {}
      }
    },
    isAdditionalDepartureForm: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isAudit: function () {
      return !!(this.request.audit || this.request.auditObject)
    }
  }
}
